import { Icon } from "Components/atoms/Icon";
import { Typography } from "Components/atoms/Typography";

import {
  ContainerDatesFlight,
  ContainerDetailsFlights,
  PassengersContent,
  StyledDatesFlight,
  StyledDetailsFlight,
  StyledDetailsHeader,
} from "./styles";

// @ts-ignore
import { ReactComponent as AdultsSvg } from "assets/svgs/adults.svg";
import { ReactComponent as ChildrenSvg } from "assets/svgs/children.svg";
import { ReactComponent as BabiesSvg } from "assets/svgs/babies.svg";
import { useSearchContext } from "shared/contexts/SearchContext";
import { getFormattedDateDetails } from "shared/utils/getFormattedDateDetails";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
import { useEffect, useState } from "react";
import { size } from "polished";

export const FlightDetailsHeader = () => {
  const { searchState } = useSearchContext();
  const [isMobile, setMobile] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  return (
    <ContainerDetailsFlights>
      <StyledDetailsHeader>
        <StyledDetailsFlight>
          <Typography
            variant={isMobile ? "h3" : "h2"}
            color="mediumGray"
            weight="semiBold"
          >
            {searchState.origin?.code || ""}
          </Typography>
          <Icon
            library="lu"
            name="LuArrowUpRight"
            size={isMobile ? "medium" : "extraLarge"}
            color="mediumBlue"
          />
        </StyledDetailsFlight>

        {searchState.destination?.code && (
          <StyledDetailsFlight>
            {Array.isArray(searchState.returnDates) &&
              searchState.returnDates.length > 0 && (
                <Icon
                  library="lu"
                  name="LuArrowDownLeft"
                  size={isMobile ? "medium" : "extraLarge"}
                  color="darkBlue"
                />
              )}
            <Typography
              variant={isMobile ? "h3" : "h2"}
              color="mediumGray"
              weight="semiBold"
            >
              {searchState.destination?.code || ""}
            </Typography>
          </StyledDetailsFlight>
        )}

        <PassengersContent>
          {searchState.adults > 0 && (
            <span>
              <AdultsSvg />
              {searchState.adults}
            </span>
          )}

          {searchState.children > 0 && (
            <span>
              <ChildrenSvg /> {searchState.children}
            </span>
          )}

          {searchState.babies > 0 && (
            <span>
              <BabiesSvg /> {searchState.babies}
            </span>
          )}
        </PassengersContent>
      </StyledDetailsHeader>

      <ContainerDatesFlight
        isColumn={
          (searchState.departureDates?.length ?? 0) >= 3 ||
          (searchState.returnDates?.length ?? 0) >= 3
        }
      >
        {searchState.departureDates &&
          searchState.departureDates.length > 0 && (
            <StyledDatesFlight>
              <Typography variant="caption" color="mediumGray" weight="bold">
                Idas:
              </Typography>

              <Typography variant="caption" color="mediumGray">
                {searchState.departureDates &&
                  searchState.departureDates?.length > 0 &&
                  searchState.departureDates
                    ?.map(
                      (date) =>
                        getFormattedDateDetails(date).day +
                        "/" +
                        getFormattedDateDetails(date).month,
                    )
                    .join(", ")}
              </Typography>
            </StyledDatesFlight>
          )}
        {searchState.returnDates && searchState.returnDates?.length > 0 && (
          <StyledDatesFlight>
            <Typography variant="caption" color="mediumGray" weight="bold">
              Voltas:
            </Typography>
            <Typography variant="caption" color="mediumGray">
              {searchState.returnDates
                ?.map(
                  (date) =>
                    getFormattedDateDetails(date).day +
                    "/" +
                    getFormattedDateDetails(date).month,
                )
                .join(", ")}
            </Typography>
          </StyledDatesFlight>
        )}
      </ContainerDatesFlight>
    </ContainerDetailsFlights>
  );
};
